import { IGenericSlider } from "../GenericSlider";
import { ISlideFactoryGeneric } from "../ISlideFactory";
import { SecondScreenHelpParams, SecondSceenHelp2Slides } from "./SecondSceenHelp2Slides";
import { SecondSceenHelp2Slides1Screens } from "./SecondScreenHelp2Slides21S";
import { SecondSceenHelp2Slides2Screens } from "./SecondScreenHelp2Slides2S";

export class FactoryDoubleSlide implements ISlideFactoryGeneric 
{
    Create(params: SecondScreenHelpParams): IGenericSlider {
        return new SecondSceenHelp2Slides(params);
    }
}

export class FactoryDoubleSlide2Screns extends FactoryDoubleSlide 
{
   
	override Create(params: SecondScreenHelpParams): IGenericSlider {
        return new SecondSceenHelp2Slides2Screens(params);
    }
}

export class FactoryDoubleSlide1Screns extends FactoryDoubleSlide 
{
   
	override Create(params: SecondScreenHelpParams): IGenericSlider {
        return new SecondSceenHelp2Slides1Screens(params);
    }
}
